"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sessionService = exports.SessionService = void 0;
const AuthClientManager_1 = require("../Session/AuthClientManager");
const GlobalSingleFlight_1 = require("../Session/GlobalSingleFlight");
const debugLog_1 = __importDefault(require("../Utils/debugLog"));
// NOTE: Remove methods used during common IAM migration
class SessionService {
    cognitoIdTokenKey = 'token';
    authClientManager = new AuthClientManager_1.AuthClientManager();
    async getSessionToken() {
        const authClient = await this.authClientManager.getAuthClient();
        const isCommonIamSession = await this.isCommonIamSession();
        if (isCommonIamSession) {
            return this.getCommonIamAccessToken(authClient);
        }
        return this.getCognitoIdToken();
    }
    async isCommonIamSession(customAuthClient) {
        const authClient = await this.authClientManager.getAuthClient(customAuthClient);
        return authClient.isAuthenticated();
    }
    async ensureAuthorizedSession(customAuthClient) {
        const isCommonIamSession = await this.isCommonIamSession(customAuthClient);
        if (!isCommonIamSession) {
            return;
        }
        const globalSingleFlight = new GlobalSingleFlight_1.GlobalSingleFlight('authPromise');
        await globalSingleFlight.run(() => this.promptLoginIfNeeded(customAuthClient));
    }
    async promptLoginIfNeeded(customAuthClient) {
        const auth0Client = await this.authClientManager.getAuthClient(customAuthClient);
        try {
            await auth0Client.getTokenSilently();
        }
        catch (getAccessTokenError) {
            if (getAccessTokenError.error !== 'login_required') {
                (0, debugLog_1.default)('Unknown error occurred during token refresh', getAccessTokenError);
                throw getAccessTokenError;
            }
            (0, debugLog_1.default)('Could not refresh access token, Login required. Opening login popup...');
            await this.promptLogin();
        }
    }
    async promptLogin(customAuthClient) {
        const auth0Client = await this.authClientManager.getAuthClient(customAuthClient);
        try {
            await auth0Client.loginWithPopup();
        }
        catch (loginPopupError) {
            (0, debugLog_1.default)('Error during login popup', loginPopupError);
            (0, debugLog_1.default)('Redirecting to Auth0 login...');
            await auth0Client.loginWithRedirect();
        }
    }
    getCognitoIdToken() {
        return localStorage.getItem(this.cognitoIdTokenKey);
    }
    async getCommonIamAccessToken(authClient) {
        const accessToken = await authClient.getTokenSilently();
        return accessToken || null;
    }
}
exports.SessionService = SessionService;
exports.sessionService = new SessionService();
//# sourceMappingURL=SessionService.js.map